import { updatesList } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/15 text-primary-400 border border-primary-500/20 mb-4">
            实时追踪
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            最新快讯
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            全天候更新，第一时间获取娱乐资讯与吃瓜动态
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-0 bottom-0 w-px bg-background-200" />

          <div className="flex flex-col gap-4">
            {updatesList.map((item) => (
              <div key={item.id} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14 group cursor-pointer">
                <div className={`absolute left-[15px] md:left-[23px] top-1.5 w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full border-2 border-background-50 ${item.tagColor} ring-2 ring-background-200/50`} />

                <span className="shrink-0 text-xs text-foreground-500 font-mono whitespace-nowrap mt-0.5">
                  {item.date}
                </span>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded text-foreground-50 whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-600">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-200 group-hover:text-primary-400 transition-colors leading-relaxed">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-8">
            <a href="#ranking" className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-background-300 hover:border-background-400 text-foreground-400 hover:text-foreground-200 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              查看更多快讯
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}